import { apiClient } from "../axiosClient";

export interface WebAuditRequest {
  name: string;
  email: string;
  phone: string;
  state: string;
  city: string;
  painPoint: string;
  domain: string;
}
export interface SocialAuditRequest {
  name: string;
  email: string;
  phone: string;
  state: string;
  city: string;
  painPoint: string;
  handle: string;
  platform: string;
}
export const startWebAudit = async (data: WebAuditRequest) => {
  const response = await apiClient.post("/audit/web", data);
  return response.data;
};

export const startSocialAudit = async (data: SocialAuditRequest) => {
  const response = await apiClient.post("/audit/social", data);
  return response.data;
};

export const getAuditStatus = async (
  type: "web" | "social",
  token: string
) => {
  const response = await apiClient.get("/audit/status", {
    params: {
      type,
      token,
    },
  });

  return response.data;
};
